// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1854) return "component.accordion-section.js?v=1751901708354";
	if (chunkId === 517) return "component.article-card.js?v=1751901708354";
	if (chunkId === 6078) return "component.asymmetric-image.js?v=1751901708354";
	if (chunkId === 1321) return "component.banner-hero.js?v=1751901708354";
	if (chunkId === 5339) return "component.cart-drawer.js?v=1751901708354";
	if (chunkId === 5301) return "component.collection-hero.js?v=1751901708354";
	if (chunkId === 7608) return "component.contact-us.js?v=1751901708354";
	if (chunkId === 2187) return "component.country-selector.js?v=1751901708354";
	if (chunkId === 4933) return "component.customers-account.js?v=1751901708354";
	if (chunkId === 494) return "component.customers-activate-account.js?v=1751901708354";
	if (chunkId === 7881) return "component.customers-addresses.js?v=1751901708354";
	if (chunkId === 4175) return "component.customers-login.js?v=1751901708354";
	if (chunkId === 6290) return "component.customers-order.js?v=1751901708354";
	if (chunkId === 1173) return "component.customers-orders.js?v=1751901708354";
	if (chunkId === 7850) return "component.customers-register.js?v=1751901708354";
	if (chunkId === 3732) return "component.customers-reset-password.js?v=1751901708354";
	if (chunkId === 7565) return "component.featured-content-new.js?v=1751901708354";
	if (chunkId === 239) return "component.featured-content.js?v=1751901708354";
	if (chunkId === 409) return "component.featured-details.js?v=1751901708354";
	if (chunkId === 2499) return "component.featured-details-new.js?v=1751901708354";
	if (chunkId === 6221) return "component.image-grid.js?v=1751901708354";
	if (chunkId === 5018) return "component.main-404.js?v=1751901708354";
	if (chunkId === 946) return "component.main-article.js?v=1751901708354";
	if (chunkId === 4260) return "component.main-blog.js?v=1751901708354";
	if (chunkId === 9971) return "component.main-cart.js?v=1751901708354";
	if (chunkId === 8409) return "component.main-collection.js?v=1751901708354";
	if (chunkId === 9484) return "component.main-list-collections.js?v=1751901708354";
	if (chunkId === 8264) return "component.main-product.js?v=1751901708354";
	if (chunkId === 3492) return "component.main-search.js?v=1751901708354";
	if (chunkId === 9574) return "component.media-blocks.js?v=1751901708354";
	if (chunkId === 6309) return "component.media-blocks-new.js?v=1751901708354";
	if (chunkId === 4279) return "component.product-carousel.js?v=1751901708354";
	if (chunkId === 93) return "component.product-filters.js?v=1751901708354";
	if (chunkId === 1569) return "component.product-gallery.js?v=1751901708354";
	if (chunkId === 7022) return "component.simple-links.js?v=1751901708354";
	if (chunkId === 8708) return "component.site-footer.js?v=1751901708354";
	if (chunkId === 3483) return "component.size-guide.js?v=1751901708354";
	if (chunkId === 8607) return "component.spacer-section.js?v=1751901708354";
	if (chunkId === 5956) return "component.splash-snippet.js?v=1751901708354";
	if (chunkId === 4690) return "component.stats-section.js?v=1751901708354";
	if (chunkId === 7722) return "component.technical-details.js?v=1751901708354";
	if (chunkId === 2514) return "component.testimonial-carousel.js?v=1751901708354";
	if (chunkId === 2078) return "component.text-accordion.js?v=1751901708354";
	if (chunkId === 2449) return "component.text-block.js?v=1751901708354";
	if (chunkId === 6816) return "component.menu-drawer.js?v=1751901708354";
	// return url for filenames based on template
	return "bundle." + chunkId + ".js?v=1751901708354";
};